export const MILLIS_PER_SECOND = 1000;
export const SECONDS_PER_DAY = 86400;
export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_IN_WEEK = 7;
export const SPEED = {
    slow: 600,
    medium: 300,
    fast: 150,
};
export const DELAY = {
    tiny: 100,
    short: 500,
    medium: 1000,
    long: 1500,
    extraLong: 3000,
};
export const PRECISION = {
    minutes: 'min',
    hours: 'hours',
    days: 'days',
};
